var styles = {
  "Radio": "pb-Radio__Radio",
  "input": "pb-Radio__input",
  "inputContainer": "pb-Radio__inputContainer",
  "label": "pb-Radio__label",
  "inputMask": "pb-Radio__inputMask",
  "inputMask--checked": "pb-Radio__inputMask--checked",
  "inputMask--invalid": "pb-Radio__inputMask--invalid",
  "radioLabel": "pb-Radio__radioLabel",
  "labelContainer": "pb-Radio__labelContainer"
};
export default styles;